import { FormList } from '@mantine/form';
import { UseFormReturnType } from '@mantine/form/lib/use-form';
import { axiosPrivate } from '../api/axios';
import { BusinessFileNames } from '../enums/business-file-names';
import { BusinessTypes } from '../enums/business-type';
import {
  MerchantFileMetadata,
  RetrieveMerchantResponse,
} from '../type/admin.types';
import { UpdateMerchantOnboardingFormValues } from '../type/update-merchant-onboarding-form-values.types';
import { getFileFromUpdateFormFile } from './merchant-onboarding';

type Files = { [type in BusinessFileNames]?: FormList<never> | FormList<any> };

export const uploadFiles = async (
  files: Files,
  userId: number,
  businessTypeId: BusinessTypes
): Promise<MerchantFileMetadata[]> => {
  const endpoint = `/web/onboard/${userId}/files`;
  let data: MerchantFileMetadata[] = [];
  const formData = new FormData();

  files[BusinessFileNames.VALID_IDS_OF_SIGNATORY]?.forEach(
    (file: File) =>
      file !== undefined &&
      file.size > 0 &&
      formData.append(
        BusinessFileNames.VALID_IDS_OF_SIGNATORY,
        new Blob([file]),
        file.name
      )
  );
  files[BusinessFileNames.VALID_IDS_OF_SIGNATORY_BACK]?.forEach(
    (file: File) =>
      file !== undefined &&
      file.size > 0 &&
      formData.append(
        BusinessFileNames.VALID_IDS_OF_SIGNATORY_BACK,
        new Blob([file]),
        file.name
      )
  );
  files[BusinessFileNames.VALID_IDS_OF_SIGNATORY_SIGNATURE]?.forEach(
    (file: File) =>
      file !== undefined &&
      file.size > 0 &&
      formData.append(
        BusinessFileNames.VALID_IDS_OF_SIGNATORY_SIGNATURE,
        new Blob([file]),
        file.name
      )
  );

  businessTypeId === BusinessTypes.STARTER &&
    files[BusinessFileNames.BARANGAY_BUSINESS_PERMIT]?.forEach(
      (file: File) =>
        file !== undefined &&
        file.size > 0 &&
        formData.append(
          BusinessFileNames.BARANGAY_BUSINESS_PERMIT,
          new Blob([file]),
          file.name
        )
    );
  businessTypeId === BusinessTypes.STARTER &&
    files[BusinessFileNames.BARANGAY_BUSINESS_PERMIT_BACK]?.forEach(
      (file: File) =>
        file !== undefined &&
        file.size > 0 &&
        formData.append(
          BusinessFileNames.BARANGAY_BUSINESS_PERMIT_BACK,
          new Blob([file]),
          file.name
        )
    );
  businessTypeId === BusinessTypes.STARTER &&
    files[BusinessFileNames.BARANGAY_BUSINESS_PERMIT_SIGNATURE]?.forEach(
      (file: File) =>
        file !== undefined &&
        file.size > 0 &&
        formData.append(
          BusinessFileNames.BARANGAY_BUSINESS_PERMIT_SIGNATURE,
          new Blob([file]),
          file.name
        )
    );

  businessTypeId === BusinessTypes.STARTER &&
    files[BusinessFileNames.STORE_PHOTO_WITH_STORE_NAME]?.forEach(
      (file: File) =>
        file !== undefined &&
        file.size > 0 &&
        formData.append(
          BusinessFileNames.STORE_PHOTO_WITH_STORE_NAME,
          new Blob([file]),
          file.name
        )
    );

  (businessTypeId === BusinessTypes.SOLE_PROPRIETOR ||
    businessTypeId === BusinessTypes.PARTNERSHIP ||
    businessTypeId === BusinessTypes.CORPORATION) &&
    files[BusinessFileNames.MAYORS_OR_BUSINESS_PERMIT]?.forEach(
      (file: File) =>
        file !== undefined &&
        file.size > 0 &&
        formData.append(
          BusinessFileNames.MAYORS_OR_BUSINESS_PERMIT,
          new Blob([file]),
          file.name
        )
    );
  (businessTypeId === BusinessTypes.SOLE_PROPRIETOR ||
    businessTypeId === BusinessTypes.PARTNERSHIP ||
    businessTypeId === BusinessTypes.CORPORATION) &&
    files[BusinessFileNames.MAYORS_OR_BUSINESS_PERMIT_BACK]?.forEach(
      (file: File) =>
        file !== undefined &&
        file.size > 0 &&
        formData.append(
          BusinessFileNames.MAYORS_OR_BUSINESS_PERMIT_BACK,
          new Blob([file]),
          file.name
        )
    );
  (businessTypeId === BusinessTypes.SOLE_PROPRIETOR ||
    businessTypeId === BusinessTypes.PARTNERSHIP ||
    businessTypeId === BusinessTypes.CORPORATION) &&
    files[BusinessFileNames.MAYORS_OR_BUSINESS_PERMIT_SIGNATURE]?.forEach(
      (file: File) =>
        file !== undefined &&
        file.size > 0 &&
        formData.append(
          BusinessFileNames.MAYORS_OR_BUSINESS_PERMIT_SIGNATURE,
          new Blob([file]),
          file.name
        )
    );

  (businessTypeId === BusinessTypes.SOLE_PROPRIETOR ||
    businessTypeId === BusinessTypes.PARTNERSHIP ||
    businessTypeId === BusinessTypes.CORPORATION) &&
    files[BusinessFileNames.BIR_CERTIFICATE_2303]?.forEach(
      (file: File) =>
        file !== undefined &&
        file.size > 0 &&
        formData.append(
          BusinessFileNames.BIR_CERTIFICATE_2303,
          new Blob([file]),
          file.name
        )
    );
  (businessTypeId === BusinessTypes.SOLE_PROPRIETOR ||
    businessTypeId === BusinessTypes.PARTNERSHIP ||
    businessTypeId === BusinessTypes.CORPORATION) &&
    files[BusinessFileNames.BIR_CERTIFICATE_2303_BACK]?.forEach(
      (file: File) =>
        file !== undefined &&
        file.size > 0 &&
        formData.append(
          BusinessFileNames.BIR_CERTIFICATE_2303_BACK,
          new Blob([file]),
          file.name
        )
    );
  (businessTypeId === BusinessTypes.SOLE_PROPRIETOR ||
    businessTypeId === BusinessTypes.PARTNERSHIP ||
    businessTypeId === BusinessTypes.CORPORATION) &&
    files[BusinessFileNames.BIR_CERTIFICATE_2303_SIGNATURE]?.forEach(
      (file: File) =>
        file !== undefined &&
        file.size > 0 &&
        formData.append(
          BusinessFileNames.BIR_CERTIFICATE_2303_SIGNATURE,
          new Blob([file]),
          file.name
        )
    );

  (businessTypeId === BusinessTypes.CORPORATION ||
    businessTypeId === BusinessTypes.PARTNERSHIP) &&
    files[BusinessFileNames.SEC_CERTIFICATE]?.forEach(
      (file: File) =>
        file !== undefined &&
        file.size > 0 &&
        formData.append(
          BusinessFileNames.SEC_CERTIFICATE,
          new Blob([file]),
          file.name
        )
    );
  (businessTypeId === BusinessTypes.CORPORATION ||
    businessTypeId === BusinessTypes.PARTNERSHIP) &&
    files[BusinessFileNames.SECRETARYS_CERTIFICATE_BACK]?.forEach(
      (file: File) =>
        file !== undefined &&
        file.size > 0 &&
        formData.append(
          BusinessFileNames.SECRETARYS_CERTIFICATE_BACK,
          new Blob([file]),
          file.name
        )
    );
  (businessTypeId === BusinessTypes.CORPORATION ||
    businessTypeId === BusinessTypes.PARTNERSHIP) &&
    files[BusinessFileNames.SECRETARYS_CERTIFICATE_SIGNATURE]?.forEach(
      (file: File) =>
        file !== undefined &&
        file.size > 0 &&
        formData.append(
          BusinessFileNames.SECRETARYS_CERTIFICATE_SIGNATURE,
          new Blob([file]),
          file.name
        )
    );

  (businessTypeId === BusinessTypes.CORPORATION ||
    businessTypeId === BusinessTypes.PARTNERSHIP) &&
    files[BusinessFileNames.AOI_AND_BY_LAWS]?.forEach(
      (file: File) =>
        file !== undefined &&
        file.size > 0 &&
        formData.append(
          BusinessFileNames.AOI_AND_BY_LAWS,
          new Blob([file]),
          file.name
        )
    );
  (businessTypeId === BusinessTypes.CORPORATION ||
    businessTypeId === BusinessTypes.PARTNERSHIP) &&
    files[BusinessFileNames.AOI_AND_BY_LAWS_BACK]?.forEach(
      (file: File) =>
        file !== undefined &&
        file.size > 0 &&
        formData.append(
          BusinessFileNames.AOI_AND_BY_LAWS_BACK,
          new Blob([file]),
          file.name
        )
    );
  (businessTypeId === BusinessTypes.CORPORATION ||
    businessTypeId === BusinessTypes.PARTNERSHIP) &&
    files[BusinessFileNames.AOI_AND_BY_LAWS_SIGNATURE]?.forEach(
      (file: File) =>
        file !== undefined &&
        file.size > 0 &&
        formData.append(
          BusinessFileNames.AOI_AND_BY_LAWS_SIGNATURE,
          new Blob([file]),
          file.name
        )
    );

  (businessTypeId === BusinessTypes.CORPORATION ||
    businessTypeId === BusinessTypes.PARTNERSHIP) &&
    files[BusinessFileNames.SECRETARYS_CERTIFICATE]?.forEach(
      (file: File) =>
        file !== undefined &&
        file.size > 0 &&
        formData.append(
          BusinessFileNames.SECRETARYS_CERTIFICATE,
          new Blob([file]),
          file.name
        )
    );
  (businessTypeId === BusinessTypes.CORPORATION ||
    businessTypeId === BusinessTypes.PARTNERSHIP) &&
    files[BusinessFileNames.SECRETARYS_CERTIFICATE_BACK]?.forEach(
      (file: File) =>
        file !== undefined &&
        file.size > 0 &&
        formData.append(
          BusinessFileNames.SECRETARYS_CERTIFICATE_BACK,
          new Blob([file]),
          file.name
        )
    );
  (businessTypeId === BusinessTypes.CORPORATION ||
    businessTypeId === BusinessTypes.PARTNERSHIP) &&
    files[BusinessFileNames.SECRETARYS_CERTIFICATE_SIGNATURE]?.forEach(
      (file: File) =>
        file !== undefined &&
        file.size > 0 &&
        formData.append(
          BusinessFileNames.SECRETARYS_CERTIFICATE_SIGNATURE,
          new Blob([file]),
          file.name
        )
    );

  businessTypeId === BusinessTypes.CORPORATION &&
    files[BusinessFileNames.GIS]?.forEach(
      (file: File) =>
        file !== undefined &&
        file.size > 0 &&
        formData.append(BusinessFileNames.GIS, new Blob([file]), file.name)
    );
  businessTypeId === BusinessTypes.CORPORATION &&
    files[BusinessFileNames.GIS_BACK]?.forEach(
      (file: File) =>
        file !== undefined &&
        file.size > 0 &&
        formData.append(BusinessFileNames.GIS_BACK, new Blob([file]), file.name)
    );
  businessTypeId === BusinessTypes.CORPORATION &&
    files[BusinessFileNames.GIS_SIGNATURE]?.forEach(
      (file: File) =>
        file !== undefined &&
        file.size > 0 &&
        formData.append(
          BusinessFileNames.GIS_SIGNATURE,
          new Blob([file]),
          file.name
        )
    );

  try {
    const response = await axiosPrivate.post(endpoint, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      withCredentials: true,
    });

    data = response.data.files;
  } catch (err: any) {
    throw err;
  }

  return data;
};

export const filesToSubmit = async (
  form: UseFormReturnType<UpdateMerchantOnboardingFormValues>,
  merchant: RetrieveMerchantResponse | undefined,
  values: typeof form.values,
  id: number | undefined
): Promise<MerchantFileMetadata[]> => {
  //currFiles are the files received upon loading update onboarding page
  let currFiles = merchant?.files as MerchantFileMetadata[];
  let formFiles = {
    [BusinessFileNames.VALID_IDS_OF_SIGNATORY]:
      values[BusinessFileNames.VALID_IDS_OF_SIGNATORY],
    [BusinessFileNames.VALID_IDS_OF_SIGNATORY_BACK]:
      values[BusinessFileNames.VALID_IDS_OF_SIGNATORY_BACK],
    [BusinessFileNames.VALID_IDS_OF_SIGNATORY_SIGNATURE]:
      values[BusinessFileNames.VALID_IDS_OF_SIGNATORY_SIGNATURE],

    [BusinessFileNames.BARANGAY_BUSINESS_PERMIT]:
      values[BusinessFileNames.BARANGAY_BUSINESS_PERMIT],
    [BusinessFileNames.BARANGAY_BUSINESS_PERMIT_BACK]:
      values[BusinessFileNames.BARANGAY_BUSINESS_PERMIT_BACK],
    [BusinessFileNames.BARANGAY_BUSINESS_PERMIT_SIGNATURE]:
      values[BusinessFileNames.BARANGAY_BUSINESS_PERMIT_SIGNATURE],

    [BusinessFileNames.STORE_PHOTO_WITH_STORE_NAME]:
      values[BusinessFileNames.STORE_PHOTO_WITH_STORE_NAME],

    [BusinessFileNames.MAYORS_OR_BUSINESS_PERMIT]:
      values[BusinessFileNames.MAYORS_OR_BUSINESS_PERMIT],
    [BusinessFileNames.MAYORS_OR_BUSINESS_PERMIT_BACK]:
      values[BusinessFileNames.MAYORS_OR_BUSINESS_PERMIT_BACK],
    [BusinessFileNames.MAYORS_OR_BUSINESS_PERMIT_SIGNATURE]:
      values[BusinessFileNames.MAYORS_OR_BUSINESS_PERMIT_SIGNATURE],

    [BusinessFileNames.BIR_CERTIFICATE_2303]:
      values[BusinessFileNames.BIR_CERTIFICATE_2303],
    [BusinessFileNames.BIR_CERTIFICATE_2303_BACK]:
      values[BusinessFileNames.BIR_CERTIFICATE_2303_BACK],
    [BusinessFileNames.BIR_CERTIFICATE_2303_SIGNATURE]:
      values[BusinessFileNames.BIR_CERTIFICATE_2303_SIGNATURE],

    [BusinessFileNames.SEC_CERTIFICATE]:
      values[BusinessFileNames.SEC_CERTIFICATE],
    [BusinessFileNames.SEC_CERTIFICATE_BACK]:
      values[BusinessFileNames.SEC_CERTIFICATE_BACK],
    [BusinessFileNames.SEC_CERTIFICATE_SIGNATURE]:
      values[BusinessFileNames.SEC_CERTIFICATE_SIGNATURE],

    [BusinessFileNames.AOI_AND_BY_LAWS]:
      values[BusinessFileNames.AOI_AND_BY_LAWS],
    [BusinessFileNames.AOI_AND_BY_LAWS_BACK]:
      values[BusinessFileNames.AOI_AND_BY_LAWS_BACK],
    [BusinessFileNames.AOI_AND_BY_LAWS_SIGNATURE]:
      values[BusinessFileNames.AOI_AND_BY_LAWS_SIGNATURE],

    [BusinessFileNames.GIS]: values[BusinessFileNames.GIS],
    [BusinessFileNames.GIS_BACK]: values[BusinessFileNames.GIS_BACK],
    [BusinessFileNames.GIS_SIGNATURE]: values[BusinessFileNames.GIS_SIGNATURE],

    [BusinessFileNames.SECRETARYS_CERTIFICATE]:
      values[BusinessFileNames.SECRETARYS_CERTIFICATE],
    [BusinessFileNames.SECRETARYS_CERTIFICATE_BACK]:
      values[BusinessFileNames.SECRETARYS_CERTIFICATE_BACK],
    [BusinessFileNames.SECRETARYS_CERTIFICATE_SIGNATURE]:
      values[BusinessFileNames.SECRETARYS_CERTIFICATE_SIGNATURE],
  };

  let uploadFormFiles = getFileFromUpdateFormFile(form);

  let newArr: MerchantFileMetadata[] = [];
  try {
    let uploadedFiles = await uploadFiles(
      uploadFormFiles,
      id as number,
      values.businessTypeId
    );

    newArr = [...uploadedFiles];

    // Filter out the removed old uploads
    const retainedFiles = currFiles.filter((oldFile) => {
      let formFilesIndex = [];

      formFilesIndex = formFiles[oldFile.fileType].map((file) => {
        if (file?.id) {
          return file.id;
        }
      });

      if (formFilesIndex) {
        return formFilesIndex.includes(oldFile.id);
      }
    });

    //Merge the retained files and the new files
    newArr = [...newArr, ...retainedFiles];
  } catch (err: any) {
    throw err;
  }
  return newArr;
};
